module.exports = __webpack_public_path__ + "img/公司介绍配图.c0f9ebe5.png";